/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/warenkorb-menu/shop.warenkorb-menu.component.ts.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {Warenkorb} from '../../../../models/warenkorb';
import {AppPageloaderService} from '../../../../services/app.pageloader.service';
import {AppWarenkorbService} from '../../../../services/app.warenkorb.service';
import {AppDialogsService} from '../../../../services/app.dialogs.service';
import {MatDialog} from '@angular/material/dialog';
import {AppShopService} from '../../../../services/app.shop.service';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {Artikel} from '../../../../models/artikel';
import {WarenkorbEntry} from '../../../../models/warenkorb-entry';
import {AppUserService} from '../../../../services/app.user.service';

/**
 * Zweck: Beschreibt class ShopWarenkorbMenuComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    templateUrl: 'shop.warenkorb-menu.component.html',
    styleUrls: ['shop.warenkorb-menu.component.scss'],
    standalone: false
})
export class ShopWarenkorbMenuComponent implements OnInit {
  static id = 'ShopWarenkorbMenuComponent';

  add_mode = false;

  newwk: Warenkorb;

  saveLabel = 'Speichern & Hinzufügen';

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private loader: AppPageloaderService, public wksvc: AppWarenkorbService,
              private dsvc: AppDialogsService, private mdsvc: MatDialog, public ssvc: AppShopService,
              @Inject(MAT_BOTTOM_SHEET_DATA) public data: { artikel: Artikel, entry: WarenkorbEntry, execAfter: any, saveLabel: any },
              private _bottomSheetRef: MatBottomSheetRef<ShopWarenkorbMenuComponent>, public usvc: AppUserService) {
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    if (this.data.saveLabel) {
      this.saveLabel = this.data.saveLabel;
    }
  }


/**
 * Beschreibt Methode save und ihren Rückgabevertrag.
 */
  save() {
    const l = this.loader.start();
    this.wksvc.createWarenkorb(this.newwk).subscribe(wk => {
      l.stop();

      if (this.data.entry && this.data.entry.artikel) {
        this.ssvc.addToWarenkorb(wk, this.data.entry);
      }
      if (this.data.execAfter) {
        this.data.execAfter(wk);
      }

      this._bottomSheetRef.dismiss();
    });
  }

/**
 * Beschreibt Methode cancel und ihren Rückgabevertrag.
 */
  cancel() {
    this.add_mode = false;
    this.newwk = undefined;
    if (this.data.execAfter) {
      this.data.execAfter(null);
    }
  }

/**
 * Beschreibt Methode add und ihren Rückgabevertrag.
 */
  add() {
    this.newwk = new Warenkorb();
    this.newwk.label = '';
    this.newwk.shared = true;
    this.add_mode = true;
  }

/**
 * Beschreibt Methode fastOrder und ihren Rückgabevertrag.
 */
  fastOrder(entry: WarenkorbEntry) {
    this.dsvc.confirm('bezahlen', 'Sofort verbindlich bestellen?',
      'Wollen Sie ' + entry.menge + ' ' + entry.artikel.Packungseinheit + ' - ' + entry.artikel.ArtikelName + ' verbindlich bestellen?', () => {
        this._bottomSheetRef.dismiss();
        this.ssvc.fastOrder(entry);

      });
  }

/**
 * Beschreibt Methode addToWarenkorb und ihren Rückgabevertrag.
 */
  addToWarenkorb(wk: Warenkorb, entry: WarenkorbEntry) {
    this._bottomSheetRef.dismiss();

    if (entry && entry.artikel) {
      this.ssvc.addToWarenkorb(wk, entry);
    }
    if (this.data.execAfter) {
      this.data.execAfter(wk);
    }
  }
}
